(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-purchase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var buttonVisible = new Map();

    function updateBars() {
      var anyVisible = false;
      buttonVisible.forEach(function (v) { if (v) anyVisible = true; });
      document.querySelectorAll('[data-lp-sticky-bar]').forEach(function (bar) {
        var owner = bar.previousElementSibling;
        var ownerBtn = owner && owner.querySelector('.lp-purchase__button');
        var scrolledPast = ownerBtn ? ownerBtn.getBoundingClientRect().bottom < 0 : false;
        bar.hidden = anyVisible || !scrolledPast;
      });
    }

    function hookForm(root) {
      var form = root.querySelector('form.lp-purchase__form');
      if (!form || form.dataset.lpHooked) return;
      form.dataset.lpHooked = 'true';
      if (window.theme && theme.AjaxProduct) {
        new theme.AjaxProduct(form);
      }
    }

    function initSection(root) {
      hookForm(root);

      var btn = root.querySelector('.lp-purchase__button');
      if (btn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { buttonVisible.set(e.target, e.isIntersecting); });
          updateBars();
        }, { threshold: 0 });
        io.observe(btn);
      }

      var bar = root.nextElementSibling;
      if (bar && bar.hasAttribute('data-lp-sticky-bar')) {
        var add = bar.querySelector('[data-lp-sticky-add]');
        var form = root.querySelector('form.lp-purchase__form');
        if (add && form) {
          add.addEventListener('click', function () {
            if (typeof form.requestSubmit === 'function') form.requestSubmit();
            else form.querySelector('.lp-purchase__button').click();
          });
        }
      }
    }

    function initAll() {
      document.querySelectorAll('[data-lp-purchase]').forEach(initSection);
      window.addEventListener('scroll', updateBars, { passive: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    // theme.js may load after this bundle: hook forms again once everything is in
    window.addEventListener('load', function () {
      document.querySelectorAll('[data-lp-purchase]').forEach(hookForm);
    });
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-lp-purchase]');
      if (root) initSection(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-whats-inside"] && !Shopify.designMode) return;
  try {
    
  function initWhatsInside(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-tile]'));
    var panel = root.querySelector('[data-panel]');
    var count = slides.length;
    var current = 0;
    if (!count) return;

    function show(index, fromTile) {
      current = (index + count) % count;
      slides.forEach(function (slide, i) { slide.hidden = i !== current; });
      tiles.forEach(function (tile, i) { tile.setAttribute('aria-selected', i === current ? 'true' : 'false'); });
      if (fromTile && window.matchMedia('(max-width: 767px)').matches) {
        panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    root.querySelector('[data-prev]').addEventListener('click', function () { show(current - 1); });
    root.querySelector('[data-next]').addEventListener('click', function () { show(current + 1); });
    tiles.forEach(function (tile, i) {
      tile.addEventListener('click', function () { show(i, true); });
    });

    var startX = null;
    panel.addEventListener('pointerdown', function (e) { startX = e.clientX; });
    panel.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) show(dx < 0 ? current + 1 : current - 1);
    });
    panel.addEventListener('pointercancel', function () { startX = null; });
  }

  document.querySelectorAll('[data-whats-inside]').forEach(initWhatsInside);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-whats-inside]');
    if (root) initWhatsInside(root);
  });

  } catch(e) { console.error(e); }
})();
})();
